import React, { useState } from 'react'
import { connect } from 'react-redux';
import { withCarto } from '../carto/withCarto';

function DpsActiveFilters(props) {
    const [expanded, setExpanded] = useState(false)
    const getButtonStyle = (isExpanded) => {
        let style = {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            minWidth: props.minWidth,
        }
        if (isExpanded) {
            style = {
                ...style,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            }
        }
        return style
    }
    return (
        <div className="dps-active-filter" style={{
            marginBottom: 4,
        }}>
            <button className="as-panel__element as-btn as-btn--secondary" style={getButtonStyle(expanded)} onClick={() => setExpanded(!expanded)}>
                <span>Active Filters</span>
                {expanded ? <i className="as-icon as-icon-chevron-up"></i> : <i className="as-icon as-icon-chevron-down"></i>}
            </button>
            {
                expanded &&
                <div className="as-panel__element as-p--16 as-body" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, width: '100%', minWidth: props.minWidth }}>
                    {
                        props.selectedLayers.map(({ layerName, label }) => {
                            const layer = props.layers[layerName] || props.dataviews[layerName]
                            return <div key={layer.name} style={{ marginBottom: 8 }}>
                                <table>
                                    <thead>
                                        <tr>
                                            <th colSpan="2">{label}</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {
                                            Object.keys(layer.filters).length > 0 ?
                                                Object.keys(layer.filters).map(filter => {
                                                    return <tr key={filter}>
                                                        <td>{layer.filterLabels[filter] || filter}</td><td>{layer.filters[filter].join(', ')}</td>
                                                    </tr>
                                                })
                                                : <tr>
                                                    <td colSpan="2">No filters applied</td>
                                                </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        })
                    }
                </div>
            }
        </div>
    )
}

const mapStateToProps = state => ({
    layers: state.carto.layers,
    dataviews: state.carto.dataviews,
});

export default connect(mapStateToProps)(withCarto(DpsActiveFilters));
